export const meta = {
  id: "FW-12",
  name: "Maison Vex",
  slug: "maison-vex",
  title: "Maison Vex — a Fable World: fashion waitlist page",
  description:
    "An original fashion waitlist designed by Fable: a three.js dolly down an atelier corridor, oxblood and calico, a seat you must request."
} as const;

export default meta;
